module.exports = __webpack_public_path__ + "img/mergeWithFirst.4ec8add2.svg";